var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileShareIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3197 6.95894C17.4476 6.84388 17.5115 6.78638 17.535 6.71793C17.5555 6.65785 17.5555 6.59215 17.535 6.53206C17.5115 6.46362 17.4476 6.40611 17.3197 6.29105L12.8824 2.29954C12.6623 2.10152 12.5523 2.00251 12.4591 2.00008C12.3781 1.99798 12.3007 2.03532 12.2495 2.10122C12.1907 2.17705 12.1907 2.32919 12.1907 2.63346V4.99478C11.0724 5.20009 10.049 5.79474 9.28848 6.68759C8.45931 7.66103 8.00064 8.92073 8 10.2264V10.5628C8.54968 9.8679 9.23599 9.30589 10.0119 8.91523C10.696 8.57081 11.4355 8.3668 12.1907 8.31304V10.6165C12.1907 10.9208 12.1907 11.073 12.2495 11.1488C12.3007 11.2147 12.3781 11.252 12.4591 11.2499C12.5523 11.2475 12.6623 11.1485 12.8824 10.9505L17.3197 6.95894Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59 3.625H5C3.89543 3.625 3 4.52043 3 5.625V15.125C3 16.2296 3.89543 17.125 5 17.125H14.5C15.6046 17.125 16.5 16.2296 16.5 15.125V12.805",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileShareIcon2);
export default __webpack_public_path__ + "static/media/fileShareIcon2.4529c25d66a2ffd0245a165f70ca7d3c.svg";
export { ForwardRef as ReactComponent };